import React from "react";
import { useTranslation } from "react-i18next";
import { FiChevronDown } from "react-icons/fi";
import { contact } from "../content/contact";
import { CALL_MINUTES } from "./Approach";
import "../styles/home.css";

const items = ["migration", "cfdi", "models", "integrator", "ai"] as const;

/** FAQ #faq (spec c.7 §8): native <details>, SAP-first, one AI question. */
const FAQ: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="faq" className="section" aria-labelledby="faq-heading">
      <div className="container faq">
        <header className="faq-head">
          <p className="t-label">{t("faq.label")}</p>
          <h2 id="faq-heading">{t("faq.title")}</h2>
          <p className="t-small faq-more">
            {t("faq.more")} <a href={`mailto:${contact.email}`}>{contact.email}</a>
          </p>
        </header>

        <div className="rows faq-list">
          {items.map((key) => (
            <details key={key} className="qa">
              <summary>
                <span>{t(`faq.items.${key}.q`)}</span>
                <FiChevronDown aria-hidden="true" focusable="false" />
              </summary>
              <div className="qa-answer">
                <p>{t(`faq.items.${key}.a`, { minutes: CALL_MINUTES })}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
